module.exports = __webpack_public_path__ + "img/tornhuset.a59eb9e8.png";